import axios from 'axios'

async function saveCaseGroupApi(caseGroup) {
  try {
    const response = await axios.post("/api/caseGroup", caseGroup )
    return response.data
  } catch (error) {
    console.error('Error saving case group.', error);
    throw error
  }
}
async function getCaseGroupsApi() {
  try {
    const response = await axios.get("/api/caseGroups")
    return response.data
  } catch (error) {
    console.error('Error getting case groups.', error);
    throw error
  }
}

async function updateCaseGroupApi(caseGroup) {
  try {
    const response = await axios.put(`/api/caseGroup/${caseGroup.id}`, caseGroup)
    return response.data
  } catch (error) {
    console.error('Error updating case group.', error);
    throw error
  }

}

async function deleteCaseGroupApi(caseGroup) {
  try {
    const response = await axios.delete(`/api/caseGroup/${caseGroup.id}`)
    return response.data
  } catch (error) {
    console.error('Error deleting case group.', error);
    throw error
  }
}




export { saveCaseGroupApi, getCaseGroupsApi, updateCaseGroupApi, deleteCaseGroupApi }